module.exports = __webpack_public_path__ + "img/c9.4d0f15f0.png";